import React from 'react'
import parse from 'html-react-parser'
import { useNotificationDataQuery } from '../core'

const NotificationBanner = () => {
  const data = useNotificationDataQuery()
  if (!data || !data.Banner_Exists) {
    return (
      <>
        <div
          className="relative z-10 h-auto overflow-hidden shadow-sm bg-secondary"
          aria-live="assertive"
          role="alert"
        >
          <a
            href="https://www.morrisons.com/more/"
            rel="noopener noreferrer"
            target="_blank"
            className="block w-full p-4 mx-auto text-lg font-medium leading-tight text-center text-white md:text-xl with-links lg:px-12 xxl:px-6 xl:max-w-screen-xl xxl:max-w-screen-xxl"
          >
            <span className="font-bold">
              The More Card is always FREE &nbsp;
            </span>
            You can apply via Morrisons.com/more or with our helpful colleagues
            in store.
          </a>
        </div>
      </>
    )
  } else {
    return (
      <>
        <div
          className="relative z-10 h-auto overflow-hidden shadow-sm bg-tertiary"
          aria-live="assertive"
          role="alert"
        >
          <div className="w-full p-4 mx-auto text-lg font-medium text-center md:text-xl with-links text-primary lg:px-12 xxl:px-6 xl:max-w-screen-xl xxl:max-w-screen-xxl">
            {parse(data.Banner_Text)}
          </div>
        </div>
        <div
          className="relative z-10 h-auto overflow-hidden shadow-sm bg-secondary"
          aria-live="assertive"
          role="alert"
        >
          <a
            href="https://www.morrisons.com/more/"
            rel="noopener noreferrer"
            target="_blank"
            className="block w-full p-4 mx-auto text-lg font-medium leading-tight text-center text-white md:text-xl with-links lg:px-12 xxl:px-6 xl:max-w-screen-xl xxl:max-w-screen-xxl"
          >
            <span className="font-bold">
              The More Card is always FREE &nbsp;
            </span>
            You can apply via Morrisons.com/more or with our helpful colleagues
            in store.
          </a>
        </div>
      </>
    )
  }
}

export default NotificationBanner
